import * as React from "react";
import type { SvgIconProps } from "../types";
import { resolveA11yProps, resolveIconSize } from "../createIcon";

export function BackoffIcon({ size, title, gradient, className, ...rest }: SvgIconProps) {
  const { width, height } = resolveIconSize(size, 16, 16);
  const a11y = resolveA11yProps(rest);

  const gradientId = React.useId();
  const stroke = gradient ? `url(#${gradientId})` : "currentColor";

  return (
    <svg
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      width={width}
      height={height}
      className={className}
      {...rest}
      {...a11y}
    >
      {title ? <title>{title}</title> : null}

      {gradient ? (
        <defs>
          <linearGradient
            id={gradientId}
            x1="0"
            y1="0"
            x2="16"
            y2="0"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#B20BFF" />
            <stop offset="1" stopColor="#0059FF" />
          </linearGradient>
        </defs>
      ) : null}

      <path
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M14 6.462H5c-1.657 0-3 1.24-3 2.769S3.343 12 5 12h3m6-5.538L11.333 4M14 6.462l-2.667 2.461"
      />
    </svg>
  );
}

export default BackoffIcon;
